import { createFileRoute } from '@tanstack/react-router'
import { ServiceSitesPage } from '../../../../features/service/sites/register-page'
import { serviceSitesSearchSchema } from '../../../../features/service/sites/search'

export const Route = createFileRoute('/_app/service/sites/')({
  validateSearch: serviceSitesSearchSchema,
  component: ServiceSitesPage,
})
